import { render, staticRenderFns } from "./CompletePostDoc.vue?vue&type=template&id=bc54c42c&scoped=true&"
import script from "./CompletePostDoc.vue?vue&type=script&lang=js&"
export * from "./CompletePostDoc.vue?vue&type=script&lang=js&"
import style0 from "./CompletePostDoc.vue?vue&type=style&index=0&id=bc54c42c&prod&scoped=true&lang=css&"
import style1 from "./CompletePostDoc.vue?vue&type=style&index=1&id=bc54c42c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc54c42c",
  null
  
)

export default component.exports